import {useEffect} from 'react'
import {
  MapContainer as RLMapContainer,
  Marker as RLMarker,
  TileLayer as RLTileLayer,
  useMap,
  useMapEvents,
} from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import {
  hasValidMapCoordinates,
  leafletMarkerIcon,
  toMapPosition,
} from './leafletMapConfig'

// react-leaflet@4 types expect full @types/leaflet; vendor-panel uses a
// minimal shim (TS 4.6 incompatible with @types/leaflet). Cast for JSX.
const MapContainer = RLMapContainer as any
const Marker = RLMarker as any
const TileLayer = RLTileLayer as any

type MapCenter = {lat: number; lng: number}

function MapClickHandler({setCenter}: {setCenter: (center: MapCenter) => void}) {
  useMapEvents({
    click(event: {latlng: {lat: number; lng: number}}) {
      setCenter({lat: event.latlng.lat, lng: event.latlng.lng})
    },
  })

  return null
}

function MapViewUpdater({position}: {position: [number, number]}) {
  const map = useMap()

  useEffect(() => {
    map.setView(position, map.getZoom())
  }, [map, position])

  return null
}

function InteractiveMap({
  center,
  setCenter,
}: {
  center: MapCenter
  setCenter: (center: MapCenter) => void
}) {
  const position = toMapPosition(center)
  const showMarker = hasValidMapCoordinates(center)

  return (
    <MapContainer center={position} zoom={10} style={{height: '100%', width: '100%'}} scrollWheelZoom>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      <MapViewUpdater position={position} />
      <MapClickHandler setCenter={setCenter} />
      {showMarker && <Marker position={position} icon={leafletMarkerIcon} />}
    </MapContainer>
  )
}

/** Address map UI — Leaflet/OSM (component name kept for import compatibility). */
export default function Home({
  center,
  setCenter,
}: {
  center: MapCenter
  setCenter: (center: MapCenter) => void
}) {
  return (
    <div style={{height: '100%', width: '100%'}}>
      <InteractiveMap center={center} setCenter={setCenter} />
    </div>
  )
}
